import React, { forwardRef } from 'react'
import cx from 'classnames'
import style from '../input.module.scss'
import { VegaIcon } from '../../icon/Icon'

export const InputCore = forwardRef(
	(
		{ name, placeholder, value, onChange, className, onBlur, errorMessage, disabled },
		ref
	) => {
		return (
			<>
				<input
					ref={ref}
					name={name}
					className={cx(style.input, className, errorMessage && style.error)}
					placeholder={placeholder}
					defaultValue={value}
					disabled={disabled}
					onChange={e => {
						if (onChange) {
							onChange(e)
						}
					}}
					onBlur={onBlur}
				/>
				{errorMessage && (
					<div className={cx(style.message, style.error)}>
						<VegaIcon name="indicator-warning" />
						<div className={style.text}>{errorMessage}</div>
					</div>
				)}
			</>
		)
	}
)
